// extracted by mini-css-extract-plugin
var _1 = "BirdviewChartCatalogFooter-modulefooter__cVds4";
export { _1 as "footer" }
